import { createTheme } from '@mui/material';
import { baseTheme as x5Theme } from '@x5-react-uikit/core';

// transform x5 colors to mui palette
const transformColors = (colors) => {
  return Object.keys(colors).reduce((acc: any, key) => {
    const item = colors[key];
    if (['attention', 'error', 'success'].includes(key)) {
      return { ...acc, state: { ...acc.state, [key]: item } };
    }
    if (typeof item === 'string') {
      return { ...acc, [key]: item };
    }
    return { ...acc, [key]: { ...item, main: item[100] } };
  }, {});
};

const muiTheme = createTheme({
  components: {
    MuiButton: {
      defaultProps: {
        variant: 'contained',
      },
    },
  },
  palette: transformColors(x5Theme.colors),
  spacing: 4,
  typography: { ...x5Theme.typography, body1: x5Theme.typography.p1 },
});

export default muiTheme;
